export const menus2 = state => {
  let arr = []
  if(state.channel.integration === 6){
    arr = state.settings.menus
  }else{
    arr = state.settings.menus.filter(item => item.t !== "Help Center")
  }
  return arr
}

export const settings = state => {
  return state.settings
}

export const tip_show = state => {
  return state.tip_show
}

export const channel_list = state => {
  return state.channel_list
}

export const channel = state => {
  return state.channel
}

export const aid = state => {
  return state.aid
}

export const active_menu = state => {
  return state.active_menu
}

export const default_sml = state => {
  return state.default_sml
}
